import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import './ListScreenSearchBar.css';

/**
 * Underline-style search control used on Practices and Inventory list screens.
 */
const ListScreenSearchBar = ({ value, onChange, inputId = 'list-screen-search-input' }) => (
  <div className="list-screen-search-wrapper">
    <label className="list-screen-search-label" htmlFor={inputId}>
      Search:
    </label>
    <div className="list-screen-search-container">
      <input
        id={inputId}
        type="text"
        className="list-screen-search-input"
        placeholder=""
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="off"
      />
      <FontAwesomeIcon
        icon={faSearch}
        className="list-screen-search-icon"
      />
    </div>
  </div>
);

export default ListScreenSearchBar;
